module.exports = __webpack_public_path__ + "img/wu.604ca3f7.png";